import React, { useState } from "react"
import { Info } from "lucide-react"
import ModalForm from "components/common/modal/ModalForm"
import { WalletTransaction } from "@/types/TransactionsType"

type CreditDemandRejectionModalProps = {
  open: boolean
  onClose: () => void
  onReject: (rejectionComment: string) => void
  transaction: WalletTransaction
}


const CreditDemandRejectionModal = ({
                                      open,
                                      onClose,
                                      onReject,
                                      transaction,
                                    }: CreditDemandRejectionModalProps) => {
  const [_comment, _setComment] = useState<string>("")
  return (
    <ModalForm
      open={open}
      onClose={onClose}
      title={`Rejeter la demande de rechargement "${transaction.reference}"`}
      submitButtonLabel={
        <span className="flex items-center gap-2">
          ✕ Confirmer le rejet
        </span>
      }
      cancelButtonLabel="Annuler"
      submitButtonProps={{
        className: "bg-red-500 hover:bg-red-600 text-white border-none",
      }}
      modalWidth="2xl"
      formSubmit={() => onReject(_comment)}
    >
      <div className="flex flex-col space-y-3">
        <p className="text-gray-600 font-bold">
          Commentaire de rejet
        </p>

        <textarea
          value={_comment}
          onChange={e => _setComment(e.target.value)}
          placeholder="Saisir le commentaire de rejet..."
          className="w-full min-h-[120px] border rounded-lg p-3 text-sm
                   focus:outline-none focus:ring-2 focus:ring-blue-300"
        />
        <p className="text-xs text-gray-500 flex items-center gap-1">
          <Info className="w-4 h-4" />
          Ce commentaire sera visible par le client
        </p>
      </div>
    </ModalForm>
  )
}

export default CreditDemandRejectionModal